<table class="table table-borderless table-striped table-hover align-middle punchout-audit-table">
  <colgroup>
    <col style="width: 130px" />
    <col />
    <col />
    <col style="width: 90px" />
    <col style="width: 130px" />
    <col style="width: 70px" />
    <col style="width: 110px" />
    <col style="width: 120px" />
  </colgroup>
  <thead>
    <tr>
      <th>{{ 'TIMESTAMP' | translate }}</th>
      <th>{{ 'PUNCHOUT_CONFIG' | translate }}</th>
      <th>{{ 'USER' | translate }}</th>
      <th>{{ 'PROTOCOL' | translate }}</th>
      <th>{{ 'PUNCHOUT_PAYLOAD_KIND' | translate }}</th>
      <th class="text-end">{{ 'ROWS' | translate }}</th>
      <th>{{ 'PUNCHOUT_AUDIT_OUTCOME' | translate }}</th>
      <th class="text-end"></th>
    </tr>
  </thead>
  <tbody>
    @for (entry of data; track entry.id) {
      <tr>
        <td>{{ entry.timestamp | date: 'yyyy-MM-dd HH:mm' }}</td>
        <td>
          {{ entry.configLabel }}
          @if (entry.configMissing) {
            <i
              class="fa-solid fa-triangle-exclamation text-warning ms-1"
              [title]="'PUNCHOUT_CONFIG_DELETED' | translate"
            ></i>
          }
        </td>
        <td>{{ entry.username || '-' }}</td>
        <td>{{ entry.protocol ? (entry.protocol | uppercase) : '-' }}</td>
        <td>{{ entry.payloadKind || '-' }}</td>
        <td class="text-end">{{ entry.rowCount ?? '-' }}</td>
        <td>
          <span class="badge" [ngClass]="outcomeClass(entry.outcome)">{{
            entry.outcome || 'UNKNOWN' | translate
          }}</span>
        </td>
        <td class="text-end">
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            [disabled]="loadingId === entry.id"
            (click)="inspect(entry)"
          >
            @if (loadingId === entry.id) {
              <i class="fa fa-spinner fa-spin me-1"></i>
            } @else {
              <i class="fa-solid fa-magnifying-glass me-1"></i>
            }
            <span>{{ 'PUNCHOUT_INSPECT' | translate }}</span>
          </button>
        </td>
      </tr>
    }
  </tbody>
</table>
